(function () {
  'use strict';

  /* ── Helpers ──────────────────────────────────────────── */
  function formatMoney(cents) {
    return window.Shopify && typeof Shopify.formatMoney === 'function'
      ? Shopify.formatMoney(cents)
      : '\u20B9' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function normalizeImageUrl(url, width) {
    if (!url) return '';
    if (url.startsWith('//')) url = 'https:' + url;
    if (!url.startsWith('http')) url = 'https:' + url;
    try {
      url = url.replace(/(_\d+x\d*|_\d*x\d+)(\.[a-z]+)(\?|$)/i, '$2$3');
      var u = new URL(url);
      u.searchParams.delete('width');
      u.searchParams.delete('height');
      if (width) u.searchParams.set('width', String(width));
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  /* ── Cart helpers ─────────────────────────────────────── */
  function getCartSectionIds() {
    var ids = [];
    ['cart-drawer', 'cart-notification', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'].forEach(function (id) {
      if (document.getElementById(id)) ids.push(id);
    });
    document.querySelectorAll('[data-section-id]').forEach(function (el) {
      var sid = el.getAttribute('data-section-id');
      if (sid && /cart|header/i.test(sid) && ids.indexOf(sid) === -1) ids.push(sid);
    });
    document.querySelectorAll('[id]').forEach(function (el) {
      if (/cart|header/i.test(el.id) && ids.indexOf(el.id) === -1) ids.push(el.id);
    });
    return ids.slice(0, 6);
  }

  function applySectionRenders(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (sectionId) {
      var html = sections[sectionId];
      if (!html) return;
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var target = document.getElementById(sectionId);
      if (target) {
        var fresh = doc.querySelector('#' + sectionId);
        target.innerHTML = fresh ? fresh.innerHTML : doc.body.innerHTML;
      }
    });
  }

  function openCartDrawer() {
    ['cart:open', 'theme:cart:open', 'cart:refresh', 'cart-notification:open'].forEach(function (ev) {
      document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
    });
    window.dispatchEvent(new CustomEvent('cart:open'));
    var triggers = [
      '[data-cart-drawer-trigger]', '[data-cart-toggle]', '[data-cart-open]',
      '.js-cart-link', '.cart-drawer__toggle', '.header__icon--cart',
      '.header-cart', '.cart-icon-wrapper a', 'a[href="/cart"]',
      '[aria-label="Cart"]', '[aria-label="Open cart"]', '[aria-label*="cart" i]'
    ];
    for (var i = 0; i < triggers.length; i++) {
      var candidates = document.querySelectorAll(triggers[i]);
      for (var j = 0; j < candidates.length; j++) {
        var el = candidates[j];
        if (el.closest('.mc-root')) continue;
        el.click();
        return;
      }
    }
  }

  function fetchAddToCart(variantId, qty, onSuccess, onError) {
    var sectionIds = getCartSectionIds();
    var body = { id: Number(variantId), quantity: Number(qty) };
    if (sectionIds.length) body.sections = sectionIds;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add to cart.');
        if (res.data && res.data.sections) applySectionRenders(res.data.sections);
        ['cart:refresh', 'cart:updated', 'theme:cart:open', 'on:cart:add'].forEach(function (e) {
          document.dispatchEvent(new CustomEvent(e, { bubbles: true }));
        });
        window.dispatchEvent(new CustomEvent('cart:refresh'));
        if (onSuccess) onSuccess(res.data);
      })
      .catch(function (err) { if (onError) onError(err); });
  }

  /* ── Quick View Modal — per section init ──────────────── */
  function initSection(sectionEl) {
    var SID = sectionEl.dataset.sid;
    if (!SID || sectionEl._mcInit) return;
    sectionEl._mcInit = true;

    var productCache = {};

    var qvOverlay = document.getElementById('mcQv-' + SID);
    var qvClose   = document.getElementById('mcQvClose-' + SID);
    var qvMainImg = document.getElementById('mcQvImg-' + SID);
    var qvThumbs  = document.getElementById('mcQvThumbs-' + SID);
    var qvDetails = document.getElementById('mcQvDetails-' + SID);
    var curVariant = null, curQty = 1;

    function setMainImage(src) {
      if (!src || !qvMainImg) return;
      var url = normalizeImageUrl(src, 800);
      qvMainImg.style.opacity = '0.3';
      qvMainImg.src = url;
      qvMainImg.onload = qvMainImg.onerror = function () { qvMainImg.style.opacity = '1'; };
    }

    function buildThumbnails(product) {
      qvThumbs.innerHTML = '';
      qvMainImg.src = '';
      if (!product.images || !product.images.length) {
        if (product.featured_image) { qvMainImg.src = normalizeImageUrl(product.featured_image, 800); qvMainImg.alt = product.title; }
        return;
      }
      product.images.forEach(function (img, idx) {
        var src = img.src || img;
        var th = document.createElement('img');
        th.className = 'qv-thumb' + (idx === 0 ? ' is-on' : '');
        th.src = normalizeImageUrl(src, 160);
        th.alt = product.title;
        th.addEventListener('click', function () {
          qvThumbs.querySelectorAll('.qv-thumb').forEach(function (t) { t.classList.remove('is-on'); });
          th.classList.add('is-on');
          setMainImage(src);
        });
        qvThumbs.appendChild(th);
      });
      setMainImage(product.images[0].src || product.images[0]);
    }

    function updatePriceAndButton() {
      if (!curVariant) return;
      var pe = document.getElementById('qvPrice-' + SID);
      var ce = document.getElementById('qvCompare-' + SID);
      var ab = document.getElementById('qvAtcBtn-' + SID);
      if (pe) pe.textContent = formatMoney(curVariant.price);
      if (ce) {
        if (curVariant.compare_at_price && curVariant.compare_at_price > curVariant.price) {
          ce.textContent = formatMoney(curVariant.compare_at_price);
          ce.style.display = '';
        } else {
          ce.style.display = 'none';
        }
      }
      if (ab) {
        ab.disabled = !curVariant.available;
        ab.textContent = curVariant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (curVariant.featured_image && curVariant.featured_image.src) {
        var cur  = qvMainImg.src.split('?')[0];
        var vurl = normalizeImageUrl(curVariant.featured_image.src, 800).split('?')[0];
        if (cur !== vurl) setMainImage(curVariant.featured_image.src);
      }
    }

    function buildOptionSelectors(product) {
      if (!product.options || !product.options.length) return '';
      var html = '';
      for (var i = 0; i < product.options.length; i++) {
        var opt = product.options[i];
        var optName = typeof opt === 'object' && opt !== null ? opt.name : opt;
        var vals = Array.from(new Set(product.variants.map(function (v) { return v['option' + (i + 1)]; })));
        html += '<div class="qv-options-group"><div class="qv-lbl">' + optName + '</div><div class="qv-option-values" data-option-index="' + i + '">';
        vals.forEach(function (val) {
          var ok = product.variants.some(function (v) { return v['option' + (i + 1)] === val && v.available; });
          html += '<button class="qv-option-btn' + (ok ? '' : ' is-na') + '" data-option-value="' + String(val).replace(/"/g, '&quot;') + '">' + val + '</button>';
        });
        html += '</div></div>';
      }
      return html;
    }

    function attachOptionListeners(product) {
      var groups = qvDetails.querySelectorAll('.qv-options-group');
      groups.forEach(function (group) {
        group.querySelectorAll('.qv-option-btn:not(.is-na)').forEach(function (btn) {
          if (btn._l) btn.removeEventListener('click', btn._l);
          btn._l = function () {
            group.querySelectorAll('.qv-option-btn').forEach(function (b) { b.classList.remove('is-on'); });
            btn.classList.add('is-on');
            var sel = [];
            groups.forEach(function (g, i) {
              var a = g.querySelector('.qv-option-btn.is-on');
              sel[i] = a ? a.dataset.optionValue : null;
            });
            var m = product.variants.find(function (v) {
              for (var i = 0; i < product.options.length; i++) {
                if (v['option' + (i + 1)] !== sel[i]) return false;
              }
              return true;
            });
            if (m) { curVariant = m; updatePriceAndButton(); }
          };
          btn.addEventListener('click', btn._l);
        });
        if (!group.querySelector('.qv-option-btn.is-on')) {
          var def = product.variants.find(function (v) { return v.available; }) || product.variants[0];
          if (def) {
            for (var i = 0; i < product.options.length; i++) {
              var dv = def['option' + (i + 1)];
              var tg = groups[i];
              if (tg) {
                var tb = Array.prototype.slice.call(tg.querySelectorAll('.qv-option-btn')).find(function (b) { return b.dataset.optionValue === dv; });
                if (tb) tb.classList.add('is-on');
              }
            }
          }
        }
      });
    }

    function buildDetails(product) {
      if (!product || !product.variants) return;
      curVariant = product.variants.find(function (v) { return v.available; }) || product.variants[0];
      curQty = 1;
      buildThumbnails(product);
      var optHtml = buildOptionSelectors(product);
      var descHtml = product.description
        ? '<button class="qv-desc-toggle" id="qvDescToggle-' + SID + '">Description <span class="qv-desc-icon">+</span></button><div class="qv-desc-body" id="qvDescBody-' + SID + '">' + product.description + '</div>'
        : '';
      qvDetails.innerHTML =
        '<h3 class="qv-title">' + product.title + '</h3>'
        + '<div class="qv-price-row"><span class="qv-price" id="qvPrice-' + SID + '">' + formatMoney(curVariant.price) + '</span>'
        + '<span class="qv-compare" id="qvCompare-' + SID + '" style="' + (curVariant.compare_at_price && curVariant.compare_at_price > curVariant.price ? '' : 'display:none') + '">' + (curVariant.compare_at_price ? formatMoney(curVariant.compare_at_price) : '') + '</span></div>'
        + optHtml
        + '<div class="qv-qty-row"><div class="qv-qty-selector">'
        + '<button class="qv-qty-btn" id="qvQtyMinus-' + SID + '">&#8722;</button>'
        + '<input class="qv-qty-input" id="qvQtyInput-' + SID + '" type="number" value="1" min="1" max="' + (curVariant.inventory_quantity > 0 ? curVariant.inventory_quantity : 999) + '" step="1">'
        + '<button class="qv-qty-btn" id="qvQtyPlus-' + SID + '">+</button>'
        + '</div><button class="qv-atc" id="qvAtcBtn-' + SID + '"' + (curVariant.available ? '' : ' disabled') + '>' + (curVariant.available ? 'ADD TO CART' : 'SOLD OUT') + '</button></div>'
        + descHtml;

      var qi = document.getElementById('qvQtyInput-' + SID);
      var qm = document.getElementById('qvQtyMinus-' + SID);
      var qp = document.getElementById('qvQtyPlus-' + SID);
      if (qi) {
        qi.addEventListener('change', function () {
          var v = parseInt(this.value);
          if (isNaN(v) || v < 1) v = 1;
          var max = curVariant.inventory_quantity > 0 ? curVariant.inventory_quantity : 999;
          if (v > max) v = max;
          curQty = v;
          this.value = v;
        });
        if (qm) qm.addEventListener('click', function () { var v = Math.max(1, curQty - 1); curQty = v; qi.value = v; });
        if (qp) qp.addEventListener('click', function () {
          var max = curVariant.inventory_quantity > 0 ? curVariant.inventory_quantity : 999;
          var v = Math.min(max, curQty + 1);
          curQty = v;
          qi.value = v;
        });
      }

      var dt = document.getElementById('qvDescToggle-' + SID);
      var db = document.getElementById('qvDescBody-' + SID);
      if (dt && db) dt.addEventListener('click', function () { var o = db.classList.toggle('is-open'); dt.classList.toggle('is-open', o); });

      var ab = document.getElementById('qvAtcBtn-' + SID);
      if (ab) ab.addEventListener('click', function () {
        if (!curVariant || !curVariant.available) return;
        ab.disabled = true;
        ab.textContent = 'Adding…';
        fetchAddToCart(curVariant.id, curQty,
          function () {
            ab.textContent = '✓ Added!';
            openCartDrawer();
            setTimeout(function () { ab.disabled = false; ab.textContent = 'ADD TO CART'; }, 2200);
          },
          function () { ab.disabled = false; ab.textContent = 'ADD TO CART'; alert('Could not add to cart.'); }
        );
      });

      attachOptionListeners(product);
      updatePriceAndButton();
    }

    function openQV(handle) {
      if (!qvOverlay) return;
      qvDetails.innerHTML = '<div class="qv-spinner-text">Loading product…</div>';
      qvMainImg.src = '';
      qvThumbs.innerHTML = '';
      qvOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (productCache[handle]) { buildDetails(productCache[handle]); return; }
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .then(function (p) { productCache[handle] = p; buildDetails(p); })
        .catch(function () { qvDetails.innerHTML = '<div class="qv-spinner-text">Failed to load. Please try again.</div>'; });
    }

    function closeQV() {
      if (!qvOverlay) return;
      qvOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      curVariant = null;
    }

    if (qvClose) qvClose.addEventListener('click', closeQV);
    if (qvOverlay) qvOverlay.addEventListener('click', function (e) { if (e.target === qvOverlay) closeQV(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && qvOverlay && qvOverlay.classList.contains('is-open')) closeQV(); });

    sectionEl.addEventListener('pc:quickview', function (e) {
      if (e.detail && e.detail.handle) openQV(e.detail.handle);
    });
  }

  /* ── Boot ─────────────────────────────────────────────── */
  document.querySelectorAll('.mc-root').forEach(initSection);

  /* Re-init Quick View after AJAX product grid swaps */
  document.addEventListener('mc:products-updated', function (e) {
    var root = e.detail && e.detail.root;
    if (root) {
      root._mcInit = false;
      initSection(root);
    }
  });

})();